export default {
  lawsAndRegulations: {
    seleteTitle: '你选择的是：',
    title1: '最高人民法院关于为海南全面深化改革开放提供司法服务和保障的意见',
    title2: '国务院关于同意设立中国(海南)自由贸易试验区的批复',
    title3: '海南省旅游条例',
    desc1:
      '法发〔2018〕16号 为深入学习贯彻习近平新时代中国特色社会主义思想和党的十九大精神，认真贯彻落实以习近平同志为核心的党中央关于支持海南全面深化改革开放的重大决策部署，充分发挥人民法院职能作用，推动海南自由贸易试验区和中国特色自由贸易港建设，根据《中共中央国务院关于支持海南全面深化改革开放的指导意见》和《最高人民法院关于为自由贸易试验区建设提供司法保障的意见》，制定如下意见。',
    desc2:
      '国务院关于同意设立中国（海南）自由贸易试验区的批复 （国函〔2018〕119号） 海南省人民政府、商务部：    你们关于设立中国（海南）自由贸易试验区的请示收悉。现批复如下：',
    desc3:
      '为保障旅游者、旅游经营者及其从业人员的合法权益，保护和合理利用旅游资源，规范旅游市场秩序，推进海南国际旅游岛建设，促进旅游业持续健康发展，根据《中华人民共和国旅游法》及有关法律、法规，结合本省实际，制定本条例。'
  },
  classType: {
    multilevel: '多级包含',
    singlelevel: '单级统计'
  },
  accountjd: {
    emailMsg: '可填写邮箱，作为登录账号',
    phoneOremail: '手机号为登录账号！',
    phoneOremail2: '邮箱为登录账号！',
    phoneMsg: '手机号或邮箱，必填一项',
    otherphoneMsg: '境外手机号不支持登录'
  },
  centerThree: {
    number: '编号：',
    countdown: '倒计时：',
    isoverdue: '已逾期：',
    mediationProgress: '调解进度',
    disputeOccurred: '纠纷发生地',
    applicant: '申请人',
    respondent: '被申请人',
    applicantsAgent: '申请人代理人',
    respondentsAgent: '被申请人代理人',
    disputeDescription: '纠纷描述',
    applicantsAppeal: '申请人诉求',
    registrationTime: '登记时间：',
    detailsDispute: '纠纷详情',
    judicial: '司法确认',
    arbitration: '在线仲裁',
    litigation: '诉讼立案',
    crossExamination: '质  证',
    applicationExtension: '申请延期',
    confirmExtension: '确认延期',
    applicationFiling: '申请立案',
    haveAppliedJudicialConfirmation: '已申请司法确认',
    ApplyJudicialConfirmation: '申请司法确认',
    haveAppliedApplicationMediation: '已申请调解申请书',
    applyApplicationMediation: '申请调解申请书',
    extensionConfirmation: '延期确认',
    numberDaysExtended: '延期天数：',
    reasonsExtension: '延期理由：',
    numberDaysExtended2: '延期天数',
    reasonsExtension2: '延期理由',
    reject: '拒 绝',
    confirm: '确 认',
    extensionCertification: '延期认证',
    reasonsApplication: '申请理由',
    pleaseEnter: '请输入内容',
    waitingMediation: '等待调解',
    inMediation: '调解中',
    mediationSucceed: '调解成功',
    mediationFail: '调解失败',
    decideWhetherWithdraw:
      '请您根据实际情况决定是否撤回，一旦撤回，调解机构将不为您提供调解服务。',
    warmPrompt: '温馨提示',
    whetherToAsk:
      '是否请求法院出具调解书，若点击"确认"，将为您跳转至请求页面。',
    tips: '提示',
    tips1: '温馨提示',
    extensionNumber: '延期必须为数字',
    enterExtension: '请输入延期理由',
    cantBeBlank: '延期理由不可为空',
    validationDidntPass: '表单验证未通过',
    confirmExtensionSucceed: '成功确认延期',
    haveRefusedExtension: '已拒绝延期',
    applicationForLitigation: '申请诉讼',
    haveAppliedForLitigation: '已申请诉讼',
    cancel: '取 消',
    orJudicial: '是否提交司法确认申请？',
    orLitigation: '是否申请诉讼立案？',
    orArbitration: '是否在线转仲裁？',
    submitApplySucceed: '提交申请成功',
    judicialed: '已申请司法确认',
    litigationed: '已申请诉讼立案',
    arbitrationed: '已申请在线仲裁',
    ApplySuitConfirmation: '诉讼',
    ApplyConfirmation: '在线仲裁',
    mediatorRecordingReminder:
      '调解员{mediatorName}已开始录制视频，请注意言辞参与调解'
  },
  menuDetail: {
    caseDetails: '案件详情',
    accept: '受理',
    notAccept: '不受理',
    allotMediators: '分配调解员',
    reallotMediators: '重新分配调解员',
    bookMediation: '预约调解',
    sendInstruments: '发送文书',
    NoobjectionMediation: '无异议调解方案',
    NoncontroversialFactsConfirmation: '无争议事实确认协议',
    mediationStatus: '调解状态',
    mediationFailed: '调解失败',
    applicationJudicialConfirmation: '司法确认申请书',
    applicationMediation: '调解申请书',
    generateElectronicFiles: '生成电子卷宗',
    signInstruments: '文书签署',
    noAgreementYet: '暂无协议',
    chooseMediator: '选择调解员',
    enterMediatorsName: '请输入调解姓名',
    choose: '选择',
    importantTips: '重要提示',
    acceptTheCase:
      '请您根据真实发生的纠纷情况决定是否受理该案件，若您选择“不受理”，将导致申请人无法享受本机构提供的调解服务。',
    notAcceptTheCase:
      '请您根据真实发生的纠纷情况决定是否受理该案件，若您选择“受理”，本机构调解员将为案件提供调解服务。',
    endingMediationReports: '终结调解报告',
    serialNumber: '流水号',
    plaintiff: '原告',
    contactNumber: '联系电话',
    contactType: '联系方式',
    agentLitem: '诉讼代理人',
    agentsPhoneNumber: '代理人电话',
    Defendant: '被告',
    reasonsToEndMediation: '终结调解原因',
    selectTheReasonsMediation: '请选择调解原因',
    enterOtherReasons: '请填写其他原因',
    plaintiffsOpinions: '原告意见：',
    enterPlaintiffsOpinions: '请填写原告意见',
    defendantsOpinions: '被告意见：',
    enterDefendantsOpinions: '请填写被告意见',
    majorDifferences: '双方主要分歧：',
    nonContentiousFacts: '双方确认的无争议事实：',
    majorDifferences2: '双方主要分歧',
    nonContentiousFacts2: '双方确认的无争议事实',
    haveSubmitted: '已提交',
    notSubmitted: '未提交',
    submit: '提交',
    haveSaved: '已保存',
    preview: '预览',
    invalid: '作废',
    confirmationMediationFailure: '调解失败确认',
    changeCaseStatus:
      '是否确认将案件状态改为“调解失败，确认后，您将结束对该案件的调解，并撰写调解终结报告',
    notAcceptCase: '不受理案件',
    detailedReasons: '详细原因',
    screeningMediationOrganization: '调解机构筛选',
    enterReasonsTransfer: '请先填写转出原因(必填)',
    selectType: '请选择类型',
    enterOrganization: '请输入机构名称',
    transfer: '转出',
    disputeInformation: '纠纷信息',
    caseMaterials: '案件材料',
    clericalMaterials: '文书材料',
    mediationRecords: '调解记录',
    notUnderOrganization: '非本机构管辖',
    otherOrganizationsAccepted: '其他机构已受理/解决',
    mediationIsntGranted: '依案件性质不予调解',
    mediationTypes: '所有调解类型',
    peopleMediation: '人民调解',
    administrativeMediation: '行政调解',
    saveSuccessfully: '保存成功',
    mediator1: '测试调解员1',
    submitSuccessfully: '提交成功',
    mediationHasFailed: '调解已失败',
    mediationTranscript: '调解笔录',
    investigationTranscript: '调查笔录',
    asssignMediatorSuccessfully: '分配调解员成功',
    transferMediationOrganizationSuccessfully: '转移调解机构成功',
    rejectSuccessfully: '不受理成功',
    acceptSuccessfully: '受理成功',
    other: '其他',
    plaintiffRequestsClosure: '原告要求终结',
    defendantRequestsClosure: '被告要求终结',
    cantDeliverToDefendant: '被告无法送达',
    contactParties:
      '调解成功！请线下和双方当事人确认，请告知双方当事人在30s内进行选择，如若不选择则默认选择撤诉处理。否则出具调解申请书',
    requestMediationAgreement: '请求出具调解书',
    withdrawCase: '撤 诉',
    pleaseWait: '请等待',
    judicail: '司法确认',
    litigation: '诉讼立案',
    arbitration: '在线仲裁',
    exitUser: {
      thisUser: '该用户',
      hasHistory: '存在历史数据',
      isOverwrite: '是否覆盖当前信息？',
      yes: '是',
      no: '否'
    }

  },
  MediationRoom: {
    mediationRoom: '调解室',
    contactsList: '联系人列表',
    noMoreMessages: '暂无更多消息',
    send: '发送',
    companyName: '企业名称',
    companyCode: '企业信用代码',
    groupChat: '群聊',
    enterContentBeforeSending: '请输入内容后发送',
    refreshAndTry: '消息发送失败，请刷新后重试',
    chatDisconnected: '聊天已断开，请刷新后重试',
    group: '群'
  },
  step3: {
    respondentsInformation: '被申请人{number}信息：',
    respondentType: '被申请人类型：',
    respondentsName: '被申请人姓名：',
    respondentGender: '被申请人性别：',
    respondent: '被申请人：',
    enterOneContact: '请至少输入被申请人{number}的一个联系方式，手机',
    enterRespondentsTel: '请输入被申请人{number}的手机号！'
  },
  step2: {
    cancel: '取消',
    legalRepresentative: '法定代表人：',
    contactNumber: '联系电话：',
    haveAdded: '已添加',
    added: '已新增',
    applicant: '申请人：',
    applicantName: '申请人姓名：',
    haveDeleted: '已删除',
    haveUpdate: '已修改',
    applicantsInformation: '申请人{number}信息：',
    examinationAndApproval: '法官审批中',
    applicantType: '申请人类型：',
    enterRealName: '请填写真实姓名',
    gender: '性别：',
    enterPhoneNumber: '请输入手机号',
    enterOneWay: '请至少输入一个联系方式，手机／电子邮箱',
    enterPhoneRequired: '请输入手机号（手机或邮箱必填一项)',
    enterEmailRequired: '请输入邮箱号（手机或邮箱必填一项）',
    IDNumber: '证件号码：',
    IDNumber2: '证件号码',
    enterIDNumber: '请填写十八位二代身份证号',
    detailAddress: '详细地址：',
    detailAddressIsRequired: '详细地址为必填项',
    useIssuingInstrument: '出具文书时使用',
    enterOrganiztionsName: '请输入单位名称',
    creditCode: '信用代码：',
    enterUnifiedSocialCreditCode: '请输入统一社会信用代码',
    enterName: '请输入姓名',
    legalPersonGender: '法人性别：',
    enterDetailedAddress: '请输入详情地址',
    organizationsRepresentative: '机构代表人：',
    representativeGender: '代表人性别：',
    agent: '代理人：',
    agent2: '代理人',
    agentType: '代理人类型：',
    Optional: '(选填)有代理人请填写代理人信息，无代理人的无需填写',
    delegateType: '委托类型：',
    agentName: '代理人姓名：',
    agentGender: '代理人性别：',
    enterUsefulTel: '请填写常用电话',
    letterAuthorization: '授权委托书：',
    uploadLetterAuthorization: '请上传授权委托书',
    telFormatIncorrect: '手机号格式不正确',
    IDCardFormatIncorrect: '身份证格式不正确',
    creditCodeFormatIncorrect: '信用代码格式错误',
    naturalPerson: '自然人',
    unincorporatedOrganization: '非法人组织',
    generalAuthorizedAgent: '一般授权代理人',
    specialAuthorizedAgent: '特别授权代理人',
    cantBeModified: '当前人员已有信息处于审批中，暂不可修改',
    expand: '展开',
    hide: '收起',
    operateAgain: '表单信息输入不正确，请重新操作',
    enterOneContact: '请至少输入申请人{number}的一个联系方式，手机',
    enterApplicantsTel: '请输入申请人{number}的手机号！',
    reuploadFile: '请重新上传文件',
    hasntLoggedIn: '用户未登录',
    deleteFile: '此操作将永久删除该文件, 是否继续',
    deletionCanceled: '已取消删除',
    nationality: '国籍：',
    selectNationality: '请选择国籍',
    national: '民族：',
    national2: '民族',
    deleteAgent: '删除代理人'
  },
  step1: {
    areasOfExpertise: '擅长领域：',
    organization: '机 构：',
    organizationType2: '机构类别',
    enter: '请填写',
    residentArea: '常住地区：',
    detailAddress: '详细地址：',
    disputeType: '纠纷类型：',
    disputeOccurred: '纠纷发生地：',
    disputeDescription2: '纠纷描述：',
    disputeDescription:
      '纠纷描述是指您申请调解的事项的基本情况，如发生纠纷的事情经过。',
    myAppeal: '我的诉求：',
    myappealPurpose: '我的诉求是指您申请调解想要达到的目的',
    mediationOrganization: '调解机构：',
    selectMediationOrganization: '选择调解机构',
    organizationType: '机构类型：',
    searchMediationOrganization: '搜索调解机构',
    number: '序号',
    fieldExpertise: '擅长领域',
    organizationLocation: '机构所在地',
    numberMediators: '调解员人数',
    pleaseSelect: '请选择',
    searchMediator: '搜索调解员',
    nextStep: '下一步',
    selectType: '请选择一个类型',
    clickStartVoice: '点击开始语音',
    province: '广东省广州市',
    selectMediationOrganizationFirst: '请先选择调解机构',
    voiceNotSupported: '当前浏览器不支持语音转文字',
    updateSecceed: '更新成功'
  },
  evidence: {
    uploadEvidence: '上传证据',
    identityCertificate: '身份证明',
    materialName: '材料名称：',
    uploadMaterial: '材料上传',
    uploader: '上传者：',
    noInformationAvailable: '暂无资料',
    listEvidence: '证据清单',
    authenticity: '真实性',
    enterReason: '请输入理由',
    accepted: '认可',
    notAccepted: '不认可',
    legality: '合法性',
    relevance: '关联性',
    crossExamination: '质证',
    opinionsCrossExamination: '质证意见',
    haveCrossExamination: '已质证',
    crossExaminationSucceed: '质证成功',
    crossexaminationCantBeBlank: '质证意见不能为空',
    chooseRecognition: '请选择对证据的认可与否的态度',
    continueDeletingfile: '是否继续删除该文件？',
    deletionSucceed: '删除成功！',
    other: '其他'
  },
  clerK: {
    uploadDocuments: '上传文书'
  },
  mediationRecord: {
    mobilePhoneNumber: '手机号：',
    mobilePhoneNumber2: '手机号',
    record: '笔录：',
    location: '地点：',
    time: '时间：',
    participant: '参会者：',
    happy: '高兴',
    angry: '愤怒',
    sad: '悲伤',
    calm: '平静',
    notStart: '未开始',
    underWay: '进行中',
    videoMediation: '视频调解',
    videoInvestigation: '视频调查',
    videoAuthentication: '视频认证',
    offlineMediation: '线下调解',
    offlineInvestigation: '线下调查',
    invitationObservation: '邀请观摩',
    enterVideo: '进入视频',
    videoRecording: '视频记录',
    sendTranscript: '发送笔录',
    viewTranscript: '查看笔录',
    faceRecognitionExpression: '人脸识别表情占比',
    videoDuration: '视频时长(分钟)',
    clickPlay: '点击播放 或 右击链接另存为',
    noRecordsYet: '暂无记录',
    enterTime: '请输入时间',
    enterDisputeType: '请输入纠纷类型',
    enterAddress: '请输入地址',
    enterDetailAddress: '请输入详细地址',
    enterDetailAddressAndNation: '请输入国家地区及详细地址',
    enterIdNumber: '请输入身份证号',
    haveSent: '已发送',
    refresh: '刷新',
    agree: '同意',
    reject: '拒绝',
    send: '发送',
    save: '保存',
    scanQR: '扫描二维码',
    signatureCompleted: '已经完成手写签名',
    afraid: '恐惧',
    annoyed: '厌恶',
    surprised: '惊奇',
    savedSuccessfully: '情绪识别保存成功',
    radarMap: '情绪识别雷达图',
    enterApplicantsName: '请输入申请人姓名',
    enterTranscript: '请输入笔录',
    enterTel: '请输入11位手机号',
    phoneError: '手机号输入错误',
    signatureNotCompleted: '还没有完成签名',
    minutes: '分钟',
    emotionalRecognition: '情绪识别'
  },
  index: {
    listCases: '我的案件列表',
    pendingMediationCases: '待调解案件',
    completedCases: '已完成案件',
    all: '全部',
    isMediating: '正在调解',
    searchNumberName: '搜索 编号/姓名',
    searchResults: '搜索结果：共{number}个案件',
    disputeNo: '纠纷编号',
    disputeNo2: '纠纷编号：',
    viewDetails: '查看详情',
    submitApplication: '申请延期提交',
    applicationCantBeBlank: '申请理由不可为空',
    listOfInquries: '我的咨询列表',
    uncompletedConsultation: '未完成咨询',
    searchByConsultation: '根据咨询编号搜索',
    consultationNo: '咨询编号',
    serviceStaff: '服务人员',
    applicationForAppeal: '申请诉求',
    disputeDescription: '纠纷描述',
    registrationTime: '登记时间',
    noData: '暂无数据'
  },
  uploadfile: {
    uploadFiles: '上传文件',
    sureUpload: '确定上传',
    classification: '分类',
    selectFile: '选择文件',
    clickUpload: '点击上传',
    tip: '提示：当前纠纷为',
    suggestedEvidence: '建议的证据有',
    limitedSize: '建议上传png、pdf、doc，docx, jpg等格式文件，且文件不超过20M',
    selectCategory: '请选择分类',
    selectMaterial: '请选择材料名称',
    uploadedFileSize: '上传文件大小不能超过 20MB',
    uploadSuccessfully: '上传成功',
    errorFileUploaded: '更新上传文件出错，请重新上传',
    cantExceed20M: '上传文件不超过20M',
    cantExceed500kb: '上传文件不超过500kb',
    refreshAndDownloadAgain: '文件已更新，请点击刷新后重新下载'
  },
  videoRecord: {
    participants: '参会人',
    uploadTime: '上传时间',
    download: '播放、下载',
    enterDetails: '请填写详细内容',
    record: '笔录',
    haveAgreed: '已同意',
    haveRejected: '已拒绝',
    scanQRCode:
      '您的调解已完成，若对于调解笔录/调解协议，无异议，请用微信扫描二维码，前往微信小程序，进行手写签名确认操作，以确保您的合法权益',
    limitedString: '长度在 2 到 5 个字符',
    selectProvincial: '请选择省市区',
    selectGender: '请选择性别',
    enterDetailedAddress: '请填写详细地址'
  },
  bookMeeting: {
    mediator2: '调解人员',
    mediator: '调解人员（视频调解最多支持8人）',
    petitionAgent: '信访代理人',
    mediationTime: '调解时间',
    now: '现在',
    reservationTime: '预约时间',
    selectDate: '选择日期',
    selectTime: '选择时间点',
    mediationLocation: '调解地点',
    reservationAddress: '预约地址',
    confirm: '确 定',
    cancel: '取消',
    plselectDate: '请选择日期',
    plselectTime: '请选择时间',
    selectOneApplicant: '请至少选择一个申请人',
    selectOneRespondent: '请至少选择一个被申请人',
    selectOneParty: '请至少选择一个当事人',
    requiredEnterTel: '该当事人需填写手机号后才可被预约调解',
    reservationSucceed: '预约成功',
    noRealNameAuthentication: '(未实名)',
    invalidDocument: '作废文书',
    invalidReason:
      '作废当前文书，该文书将被丢弃。需要调解员重新生成文书并签署。作废原因：',
    invalidPlaceholder: '请输入作废原因',
    orPreview: '文件不可以预览',
    insuccess: '作废成功！',
    infail: '作废失败！'
  },
  workbench: {
    HasBeenCanceled: '已取消',
    accountType: '帐号类型',
    continue: '继续',
    organizationsRepresentative: '机构代表人',
    physicalDiscomfort: '身体不适',
    muchWork: '近期工作多',
    noRelevantExperience: '个人没有相关经验',
    notSuitableOrganization: '纠纷不适合本机构',
    next: '下一步，填写调解方案',
    applicant: '申请方',
    respondent: '被申请方',
    legalRepresentative: '法定代表人',
    enterLegalRepresentative: '请输入法定代表人',
    enterOrganizationRepresentative: '请输入机构代表人',
    socialCreditCode: '社会信用代码',
    enterSocialCreditCode: '请输入社会信用代码',
    IDIncorrect: '身份证号不正确',
    tel: '手机号码',
    tel2: '手机号码：',
    enterTel: '请输入手机号码',
    email: '电子邮箱：',
    email2: '电子邮箱',
    address: '住址',
    enterEmail: '请输入电子邮箱',
    formatIncorrect: '邮箱格式不正确',
    enterAgentsName: '请输入代理人姓名',
    enterAgentsTel: '请输入代理人电话',
    enterAgentsIDNumber: '请输入代理人身份证号',
    enterIDNumber: '请输入18位身份证号',
    enterRespondentsName: '请输入被申请人姓名',
    enterCorrectTel: '请输入正确的手机号码',
    telIncorrect: '手机号码不正确',
    mainFacts: '纠纷主要事实，争议事项：',
    followingAgreements: '经调解，自愿达成如下协议：',
    writieMediationOrganization:
      '当事人已书面同意本调解组织适用无异议调解认可制度。先就本纠纷提出以下调解方案：',
    mediationProcess: '调解过程：',
    afterMediation: '经调解，当事人无争议的事实如下：',
    haveSigned: '皆已签署',
    residenceAddress: '常住地址',
    residenceAddress2: '常住地址：',
    organizationAddress: '单位地址',
    organizationAddress2: '单位地址：',
    groupAddress: '机构地址',
    whetherToContinue:
      '联系方式为固话，文书发起后无法收到并签署文书, 是否继续？',
    sendSave: '发送的同时完成保存操作, 是否继续?',
    enterCorrectInformation: '信息验证未通过，请填写正确的信息',
    save: '发送成功的同时完成保存操作, 是否继续？',
    errorInSigning: '签名出错'
  },
  status: {
    detailedReasons: '详细原因：',
    confirmMediationAgreement: '双方都确认调解协议',
    other: '其它',
    reason: '原因',
    dontReachMediationAgreement: '双方调解协议未达成一致',
    applicantWantMediation: '申请人不想调解',
    respondentWantMediation: '被申请人不想调解',
    mediationSucceed: '案件调解成功！',
    selectStatus: '请选择状态',
    plaintiffsName: '原告姓名',
    plaintiffsContactNumber: '原告联系电话',
    defendantsName: '被告姓名',
    DefendantsContactNumber: '被告联系电话',
    mediationNotes: '调解情况备注：',
    fillMediationNotes: '请填写调解备注',
    didntAgree: '双方调解协议未达成一致',
    applicantDoesntWantMediation: '申请人不想调解',
    respondentDoesntWantMediation: '被申请人不想调解',
    plaintiffRequestsForClosure: '原告要求终结',
    defendantRequestsForClosure: '被告要求终结',
    cantDeliverToDefendant: '被告无法送达'
  },
  judicial: {
    claimMatters: '请求事项',
    claimMatters2: '请求事项：',
    factsAndReasons: '事实与理由',
    factsAndReasons2: '事实与理由：',
    courtAcceptedApplication: '申请受理法院：',
    selectCourt: '请选择受理法院',
    caseType: '案件类型',
    selectCaseType: '请选择案件类型',
    selectCause: '请选择案由',
    causeAction: '案由：',
    civil: '民事',
    guangzhou: '广州互联网法院',
    selectCourtCase: '请选择 受理法院 和 案件类型',
    reselect: '当前法院和案件类型下没有案由，请重新选择',
    entrustedAgent: '委托代理人',
    turnOnSpeechRecognition: '开始语音识别',
    description:
      '说明：调解成功后,本系统将就本案自动向法院申请撤案。撤回立案申请不影响后续向法院申请司法确认或出具调解书。',
    description2:
      '本人同意司法机关在海南法院涉外民商事法庭案件多元化解平台上向本人电子送达法律文书（包括但不限于司法确认民事裁定书或民事调解书）。送达地址以调解协议填写为准。'
  },
  caseInfo: {
    sureToDelete: '确定要删除吗？',
    duringMediation:
      '调解过程中，删除当事人会导致与已发送的文书中的当事人不一致'
  },
  partyBook: {
    applicant: '申请人1',
    mainFacts: '纠纷主要事实，争议事项不能为空',
    uponMediation: '经调解，自愿达成如下协议不能为空',
    description1:
      '说明：1.调解成功后,本系统将就本案自动向法院申请撤案。撤回立案申请不影响后续向法院申请司法确认或出具调解书。',
    description2:
      '2.本人同意司法机关在海南法院涉外民商事法庭案件多元化解平台上向本人电子送达法律文书（包括但不限于司法确认民事裁定书或民事调解书）。送达地址以调解协议填写为准。',
    mediationProgramme: '调解方案不能为空',
    haveObjections: '有异议',
    agreeSave: '同意并保存',
    dissidentsName: '请输入异议人姓名',
    dissident: '异议人',
    incorrectEmailAddress: '电子邮箱不正确',
    mailingAddress: '邮寄地址',
    objectionsDescription: '异议描述',
    commitmentMediationProgramme: '无异议调解方案承诺书',
    statementProtest: '异议书',
    requiredFields: '有必填项未填写'
  },
  //   infocenter
  serviceinfo: {
    personalCenter: '个人中心',
    individualImformation: '个人信息',
    edit: '编辑',
    avatar: '头像',
    basicInformation: '基本资料',
    politicalStatus: '政治面貌',
    IDNumber: '身份证号',
    uploadIDCard: '身份证上传',
    front: '正面',
    reverseSide: '反面',
    name: '姓名',
    gender: '性别',
    dateOfBirth: '出生日期',
    contactPhone: '联系手机',
    landline: '固定电话',
    contactEmail: '联系邮箱',
    degreeOfEducation: '文化程度',
    occupationInformation: '职业资料',
    areasOfExpertise: '擅长领域',
    qualificationCertificate: '资格证书',
    uploadTheCertificate: '证书上传',
    occupation: '职业',
    workingOrganization: '工作机构',
    workAddress: '工作地址',
    detailAddress: '详细地址',
    timeToStartWorking: '开始工作时间',
    careerExperience: '从业经历',
    platformFunction: '平台职能',
    typeOfFunction: '职能类型',
    serviceOrganization: '服务机构',
    serviceArea: '服务地区',
    delete: '删除',
    add: '添加',
    save: '保存',
    phoneNumberFormatError: '手机号格式错误',
    wrongIDNumberFormat: '身份证号格式错误',
    enterName: '请输入姓名',
    enterPhoneNumber: '请输入手机号',
    selectFunctionType: '请选择职能类型',
    selectServiceOrganization: '请选择服务机构',
    selectServiceArea: '请选择服务地区',
    CommunistPartyofChina: '中共党员',
    ProbationaryPartyMembers: '中共预备党员',
    leagueMember: '共青团员',
    MDC: '民革党员',
    CDL: '民盟盟员',
    CDNCA: '民建会员',
    DPP: '民进会员',
    CPWDP: '农工党党员',
    thePublicParty: '致公党党员',
    JiusanSocietyMembers: '九三学社社员',
    TDSL: '台盟盟员',
    nonpartyPersonage: '无党派人士',
    ordinaryResident: '普通居民',
    editPersonalInformation: '编辑个人信息成功',
    militaryOfficerCard: '军官证',
    passport: '护照'
  },
  setaccount: {
    accountType: '帐号类型',
    accountSetting: '帐号设置',
    newAccountNumber: '新帐号',
    newAccountNumber2: '新帐号（手机号）',
    enternewAccountNumber: '请输入新帐号（手机号）',
    mobilePhoneNumber: '手机号',
    verificationCode: '验证码',
    getTheVerificationCode: '获取验证码',
    enterNewAccount: '请输入新帐号',
    enterTheSMSVerificationCode: '请输入短信验证码',
    resend: '重新发送',
    modifyPasswordSuccessfully: '修改手机号成功，即将跳转到首页'
  },
  setpwd: {
    modifyPassword: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    inconsistentPasswordsEntered: '两次输入密码不一致',
    pleaseEnter: '请输入8-16位，需包含大小写字母、数字和特殊符号',
    enterOldPassword: '请输入旧密码',
    enterNewPassword: '请输入8-16位，需包含大小写字母、数字和特殊符号',
    enterPasswordAgain: '请再次输入新密码',
    modifyPasswordSuccessfully: '修改密码成功，即将跳转到首页',
    organizationInformation: '机构信息'
  },
  orginfo: {
    organizationsName: '机构名称',
    administrativeLevel: '行政级别',
    administrativeLevel2: '行政级别：',
    pleaseSelect: '请选择',
    superiorOrganization: '上级单位',
    superiorOrganization2: '上级单位：',
    telephoneLandline: '电话座机',
    telephoneLandline2: '电话座机：',
    groupAddress: '机构地址',
    groupAddress2: '机构地址：',
    affiliatedLocation: '所属地区',
    organizationType: '机构类型',
    organizationCode: '组织机构代码',
    organizationCode2: '组织机构代码：',
    organizationCodeCertificate: '组织机构代码证',
    provincial: '省级',
    municipalLevel: '市级',
    districtCountyLevel: '区/县级',
    court: '法院',
    generalOrganization: '普通机构',
    selectOrganizationType: '请选择机构类型',
    enterTheOrganizationAddress: '请输入机构地址',
    enterTheTelephoneLandline: '请输入电话座机',
    selectAffiliatingArea: '请选择所属地区',
    editingSucceed: '机构信息编辑成功'
  },
  //   statAnalysis
  platformap: {
    statisticalAnalysis: '统计分析',
    disputeMap: '纠纷地图',
    selectDate: '选择日期',
    startDate: '开始日期',
    endingDate: '结束日期',
    inquire: '查询',
    selectCity: '选择城市',
    pleaseSelectCity: '请选择城市',
    export: '导出',
    allStreets: '所有街道',
    street: '街道',
    numberOfDisputeMediationInTheStreet: '街道的纠纷调解数量',
    numberOfDisputeMediation: '机构纠纷调解数量',
    TrendOfGuangzhou: '海口市调解走势',
    number: '序号',
    organizationsName: '机构名称',
    administrator: '管理员',
    contactWay: '联系方式',
    mediatorsWithinTheEstablishment: '在编调解员',
    numberOfDisputes: '纠纷数量',
    previousPage: '上一页',
    nextPage: '下一页',
    numberOfUserRegistrations: '用户注册量',
    numberOfMediationOrganizations: '调解机构数',
    numberOfMediators: '调解员数量',
    numbeMediationCases: '调解案件量',
    numberOfSuccessfulMediation: '调解成功数量',
    failedMediationsAmount: '调解失败数量',
    numberOfJudicialConfirmations: '司法确认案件数量',
    totalNumberOfLitigationCases: '诉讼案件总量',
    totalConsultations: '咨询总量',
    mediate: '调解',
    consult: '咨询',
    judicial: '司法确认',
    litigation: '诉讼',
    arbitration: '仲裁'
  },
  userstatistics: {
    userStatisticsList: '用户统计列表',
    totalVisits: '访问总量',
    numberOfRegisteredUsers: '注册量',
    serviceStaff: '服务人员',
    serviceOrganization: '服务机构',
    accessingUserVolumeStatistics: '访问用户量统计',
    statisticsOfRegisteringUsers: '注册用户统计',
    serviceStaffStatistics: '服务人员统计',
    resourceMap: '资源地图',
    thematicAnalysisOfDisputes: '专题报告'
  },
  disputesubject: {
    typedCases: '类型案件',
    analysisOfConsultationTrend: '咨询走势分析',
    analysisOnMediationCasesTrend: '调解案件走势分析',
    analysisOfTheMediationCases: '街道调解案件数量分析',
    parameterDimensionAnalysis: '调解案件参数维度分析',
    applicantRoleAnalysis: '申请人角色分析',
    mediationStatusAnalysis: '调解状态分析',
    analysisOfMediationResult: '调解结果分析',
    variousTypesOfDisputeMediation: '各街道各类型纠纷调解数据',
    selectOneDisputeType: '请选择至少一种纠纷类型',
    disputesHaveBeenSelected: '已选择{number}纠纷类型',
    numberOfConsultations: '咨询案件数量',
    numberOfCases: '咨询转调解案件数量',
    proportion: '咨询转调解比例',
    waitingForAcceptance: '等待受理',
    waitingMediation: '等待调解',
    inMediation: '调解中',
    ended: '已结束',
    individual: '个人',
    legalPerson: '法人',
    unincorporatedOrganization: '非法人组织',
    closed: '已结案',
    mediationSucceed: '调解成功',
    mediationFailed: '调解失败',
    withdrawCase: '撤回案件'
  },
  //   admin
  role: {
    rolePermission: '角色权限',
    rolePermission2: '角色权限：',
    roleManagement: '角色管理',
    roleType: '角色类型：',
    roleType2: '角色类型',
    newRoleName: '新增角色名称',
    roleName: '角色名称',
    roleName2: '角色名称：',
    creater: '创建人',
    creationTime: '创建时间',
    remark: '备注',
    remark2: '备注：',
    operate: '操作',
    view: '查看',
    modify: '修改',
    counselor: '咨询师',
    customerService: '客服',
    judge: '法官',
    newOrganization: '新增机构'
  },
  roleEdit: {
    roleInformation: '角色信息',
    roleCode: '角色代码：',
    selectOnePermission: '请至少选择一个权限',
    enterRoleName: '请输入角色名称',
    enterRoleCode: '请输入角色代码',
    enterRoleType: '请输入角色类型',
    normalUser: '普通用户',
    modifyingRuleSucceed: '修改角色成功',
    addingRoleSucceed: '添加角色成功'
  },
  organizationEdit: {
    organizationManagement: '机构管理',
    organizationInformation: '机构信息',
    organizationsName: '机构名称',
    organizationType: '机构类型',
    administrativeLevel: '行政级别',
    organizationsContacts: '机构联系人',
    organizationsContacts2: '机构联系人：',
    mediationType: '调解类型',
    mediationType2: '调解类型：',
    contactsTelephone: '联系人手机号',
    contactsTelephone2: '联系人手机号：',
    superiorOrganization: '上级单位',
    organizationCode: '组织机构代码',
    telephoneLandline: '电话座机',
    groupAddress: '机构地址',
    organizationCertificate: '组织机构证书：',
    enterOrganization: '请输入机构名称',
    enterOrganizationalContact: '请输入机构联系人',
    enterContactsPhone: '请输入联系人手机号',
    selectAdministrativeLevel: '请选择行政级别',
    selectOrganizationType: '请选择机构类型',
    selectMediationType: '请选择调解类型',
    enterTheTelephoneLandline: '请输入电话座机',
    selectTypeOfDispute: '请选择纠纷类型',
    selectOrganizationAddress: '请选择机构地址',
    lawOffice: '律所',
    addingOrganizationSucceed: '添加机构成功',
    modifyingOrganizationSucceed: '修改机构成功'
  },
  accountEdit: {
    accountManagement: '帐户管理',
    workersAccountInformation: '工作人员帐户信息',
    basicInformation: '基本资料',
    politicalStatus: '政治面貌',
    contactEmail: '联系邮箱',
    degreeOfEducation: '文化程度',
    dateOfBirth: '出生日期：',
    occupationInformation: '职业资料',
    separateWithCommas: '请用中文逗号隔开，如：婚姻纠纷，财产分配',
    qualificationCertificate: '资格证书',
    typeOfOccupation: '职业类型',
    workAddress: '工作地址',
    careerExperience: '从业经历',
    platformFunctionRoles: '平台职能角色',
    affiliatedOrganization: '所属机构',
    selectSubsidiaryOrganization: '请选择所属机构',
    affiliatedArea: '所属区域',
    selectArea: '请选择所属区域',
    selectOrganization: '请选择机构',
    separateAreasOfExpertise: '擅长领域请用中文逗号分隔',
    wrongIDNumberFormat: '身份证号格式错误',
    enterName: '请输入姓名',
    enterPhoneNumber: '请输入手机号',
    selectRoleType: '请选择角色类型',
    selectRoleName: '请选择角色名称',
    modifyingWorkerSucceed: '修改工作人员成功',
    addingWorkerSucceed: '添加工作人员成功'
  },
  account: {
    accountStatus: '账号状态',
    accountStatus2: '账号状态：',
    inUse: '使用中',
    deactivated: '已停用',
    deactivation: '停用',
    startUsing: '启用',
    paused: '已暂停',
    noData: '查无数据',
    statusModificationSucceed: '状态修改成功',
    addAccount: '新增账户'
  },
  abilityTempleEdit: {
    1: '新建模板',
    templateName: '模板名称',
    assessmentCycle: '评估周期',
    applicableObjects: '适用对象',
    indexWeight: '指标权重',
    sumWeights: '(权重之和应为100%)',
    assessmentIndicators: '评估指标',
    indexDescription: '指标说明',
    index: '指标权',
    enterWeights: '请输入权重(例：20%)',
    getProcessingRate: '处理率=已调解案件数/（已调解案件数+正在调解案件数）',
    getSuccessRate: '成功率=案件调解成功数/已调解案件数',
    assessmentResult: '评估结果',
    score: '得分',
    grade: '等级',
    example: '(例：0~50)',
    enterTemplateName: '请输入模板名称',
    selectAssessmentCycle: '请选择评估周期',
    selectApplicableObject: '请选择适用对象',
    processingRate: '处理率',
    SuccessRateOfMediated: '该周期内已调解案件成功率',
    satisfaction: '满意度',
    partiesSatisfaction: '评估周期内当事人对调解过程的满意度',
    successRate: '成功率',
    duringTheAssessmentCycle: '估周期内已调解案件成功率',
    fillInformation: '请把模板信息填写完整哦'
  },
  abilityTemple: {
    competencyAssessmentAnalysis: '能力评估分析',
    whetherContinue: '此操作将永久删除该文件, 是否继续?',
    deletionCanceled: '已取消删除'
  },
  //  consultant
  finishDetail: {
    completedConsultation: '已完成咨询',
    consultationDetails: '咨询详情',
    inAConversation: '与xxx的交谈中',
    caseNo: '案件编号',
    caseType: '案件类型',
    viewDisputeDetails: '查看纠纷详情',
    consultationIsEnd: '咨询已结束',
    pleaseEnter: '请输入内容',
    consultationTime: '咨询时间',
    MondayToFriday: '（周一至周五9:00-18:00）',
    listOfEvidence: '证据列表',
    attachmentsDownloadSucceeded: '附件下载成功'
  },
  detail: {
    calculator: '计算器',
    sendingFiles: '发送文件',
    clickUpload: '点击上传',
    canBeUploaded: '只能上传doc/docx/png/jpg/txt文件',
    total: '共(0)条',
    inVoice: '语音中',
    voiceNotSupported: '当前浏览器不支持语音转文字',
    reuploadFile: '请重新上传文件',
    uploading: '正在上传，请稍后',
    errorFileUploaded: '更新上传文件出错，请重新上传',
    uploadSuccessfully: '上传成功',
    selectFirst: '请先选择文件',
    mediated: '已调解'
  },
  //   dtuMediation
  peoMediation: {
    applicationNotice: '申请须知',
    tip1:
      '1.请您根据真实发生的纠纷情况如实登记信息，为了更好地为您服务，请您确认填写信息的正确和完整。',
    tip2:
      '2.在您申请调解后三天内，将由调解机构管理员决定是否受理并为您分配相应的调解员，调解员将电话联系您了解纠纷情况。案件全流程将进行短信通知，请您保持电话畅通。',
    tip3:
      '3.代理人是以被代理人名义进行代理活动的人。若您填写您的代理人。该代理人将在您的授权范围内以您的名义进行本次调解相关的民事活动。填写纠纷详情',
    fillDisputeDetails: '填写纠纷详情',
    fillApplicantsInformation: '填写申请人信息',
    fillRespondentInformation: '填写被申请人信息'
  },
  onlineMediation: {
    fillConsultationInformation: '填写咨询信息',
    selectCounselor: '选择咨询师',
    evaluateTheCounselor: '咨询结束并评价咨询师'
  },
  applyAssess: {
    submitAnApplication: '提交申请',
    applicationForAssessmentReport: '申请评估报告',
    assessmentReportGeneration: '评估报告生成',
    viewEvaluationReport: '查看评估报告'
  },
  //   login
  loginstaff: {
    signInWithPhone: '手机号登录',
    forgotPassword: '忘记密码？'
  },
  findpwd: {
    enterEmail: '请输入邮箱',
    getEmailVerification: '获取邮箱验证码',
    enterTheEmailVerificationCode: '请输入邮箱验证码',
    verifyEmail: '验证邮箱',
    enterPhoneNumber: '请输入手机号',
    enterVerificationCode: '请输入验证码',
    enterTheSMSVerificationCode: '请输入短信验证码',
    getSMSVerification: '获取短信验证码',
    enterNewPassword: '请输入8-16位，需包含大小写字母、数字和特殊符号',
    enterNewPasswordAgain: '请再次输入新密码',
    verifyPhoneNumber: '验证手机号',
    resetPassword: '重置密码',
    pleaseEnter: '请输入8-16位，需包含大小写字母、数字和特殊符号',
    reenterPassword: '两次输入密码不一致，请重新输入',
    passwordResetSucceeded: '密码重置成功, 3秒后跳转到登录页',
    phoneNumberFormatError: '手机号格式错误',
    emailFormatError: '邮箱格式错误',
    enterGraphicalVerificationCode: '请输入图形验证码',
    graphicalVerificationCodeError: '图形验证码错误',
    resend: '重新发送',
    phoneNumberOrEmailFormatError: '手机号或邮箱格式错误'
  },
  //   register
  register: {
    registerWithPhoneNumber: '手机号注册',
    registerWithEMail: '邮箱注册',
    enterPhoneNumber: '请输入手机号',
    enterTheSMSVerificationCode: '请输入短信验证码',
    getTheVerificationCode: '获取验证码',
    enterThePassword: '请输入密码',
    agree: '我同意',
    resend: '重新发送',
    register: '注册',
    emailFormatError: '邮箱格式错误',
    activateLogin: '邮件已发送，请前往您的邮箱进行激活登录',
    registerWithEMailOrPhoneNumber: '请输入邮箱或手机号'
  },
  //   userCenter
  evlaLetter: {
    userReviews: '用户评价',
    trainingMaterials: '培训材料',
    starRating: '星级评价',
    numberOfAssessments: '评价数',
    numberOfAssessments2: '评价数：',
    caseNo: '案件编号',
    assessorsName: '评价人姓名',
    assessmentTime: '评价时间',
    starLevel: '星级',
    starLevel2: '星 级：',
    content: '内容'
  },
  ace_api: {
    noCameraDetected: '没有检测到摄像头,请检测好是否有音视频设备',
    noCamera: '没有检测到摄像头',
    verificationSucceed: '验证成功',
    browserDoesntSupport: '您的浏览器暂时不支持获取用户'
  },
  info: {
    basicInformation: '基本资料',
    currentAvatar: '当前头像：',
    fileLimited: '仅支持png、jpg图片文件，且文件应小于1M',
    realName: '真实姓名：',
    currentResidenceArea: '现居地区：',
    detailAddress: '详细地址：',
    permanentResidenceAddress: '户籍地址：',
    onlyBeFormat: '上传头像图片只能是 JPG或者PNG 格式',
    cantExceed1MB: '上传头像图片大小不能超过 1MB!',
    male: '男',
    female: '女',
    other: '其他',
    enterIDNumber: '请输入身份证'
  },
  security: {
    yourSecurityLevel: '您的安全等级',
    securityLevel: '安全等级',
    completeAllBindings: '完成全部绑定，提升账户安全',
    identityAuthentication: '身份认证',
    improveAccountSecurity:
      '提升账户安全级别和信任级别，认证后将无法修改认证信息',
    bindPhone: '绑定手机',
    improveSecurity: '绑定手机，可以提高安全性及找回密码等功能',
    bindEmail: '绑定邮箱',
    bindEmailHelp: '绑定邮箱，可以提高安全性和信息的通知',
    modifyPassword: '修改密码',
    modifyMail: '修改邮箱',
    newMail: '新邮箱',
    originalPassword: '原密码不能为空',
    originalPas: '原密码',
    enterOriginalPas: '请输入原密码',
    enterMail: '请输入邮箱地址',
    newPas: '新密码',
    newPasswordCantBeBlank: '新密码不能为空',
    confirmPasswordBlank: '确认密码不能为空',
    modifyBindingPhone: '修改绑定手机号',
    moreThan8Digits: '设置包含数字和字母，长度应为8位以上',
    enterPasswordAgain: '请再次输入密码',
    inconsistentPasswordsEntered: '两次输入密码不一致',
    enterPhoneNumber: '请输入手机号',
    telFormatIncorrect: '手机号格式不正确',
    certified: '已认证',
    setUp: '设置',
    enterCorrectEmailAddress: '请输入正确的邮箱地址',
    goauthentication: '去认证',
    validationDidntPass: '表单验证未通过',
    cantBeTheSameAsTheOriginals: '新手机号不能与原手机号相同',
    newPhone: '新手机',
    hasBeenCertified: '已实名',
    modificationSucceed: '修改成功',
    score: '分'
  },
  centerTwo: {
    inProgress: '评估报告进行中',
    application: '评估报告申请完成',
    assessmentProgress: '评估进度',
    noAssessmentRequested: '评估未申请',
    applicationForAssessmentReport: '申请评估报告',
    generateTheAssessmentReport: '生成评估报告',
    viewEvaluationReport: '查看评估报告',
    noAssessmentReportRequested: '评估报告未申请',
    assessmentReport: '评估报告申请中',
    initiateTheAssessment: '发起评估',
    judicialConfirmation: '司法确认'
  },
  centerSix: {
    enterQueryPassword: '输入查询密码',
    queryPassword: '查询密码',
    enterTheQueryPassword: '请输入查询密码',
    caseStatus: '案件状态',
    causeActionType: '案由类型',
    courtForApplication: '申请法院',
    applicantsAppeal: '申请人诉求',
    applicationForMediation: '调解申请书详情',
    mediationApplicationApplication: '调解申请书申请',
    waitingForConfirmation: '等待确认',
    accepting: '受理中',
    confirmEffectiveness: '确认有效',
    filingProgressInquiry: '立案进度查询'
  },
  centerSeve: {
    ApplyJudicialConfirmation: '申请司法确认',

    consultationProgress: '咨询进度'
  },
  centerOne: {
    viewRecords: '查看记录',
    manualConsultation: '人工咨询',
    fillApplication: '填写申请',
    consultationEnds: '结束咨询',
    initiateTheConsultation: '发起咨询',
    applicationForLitigation: '诉讼申请'
  },
  centerFour: {
    proceedingDetails: '诉讼详情',
    registrationTime: '登记时间',
    fileACaseOnline: '在线申请立案',
    waitingForAcceptance: '等待受理',
    filingSucceed: '立案成功',
    accessToLitigation: '进入诉讼',
    detailsOfJudicialConfirmation: '司法确认详情'
  },
  centerFive: {
    registrationTime: '登记时间：'
  },
  registration: {
    disputeList: '纠纷登记列表',
    addDispute: '添加纠纷',
    myDispute: '我的纠纷登记'
  },
  //   mediator
  judicialConfirm: {
    naturalPerson: '自然人：',
    legalPerson: '法人：',
    unincorporatedOrganization: '非法人组织：',
    organiztionsName: '单位名称：',
    ApplyJudicialConfirmation: '申请司法确认',
    basicInformation: '基本信息',
    courtAcceptedApplication: '申请受理法院',
    caseType: '案件类型',
    caseType2: '案件类型：',
    partysBasicInformation: '当事人基本信息',
    required: '必填',
    instrumentDeliveryAddress: '文书送达地址',
    instrumentDeliveryAddress2: '文书送达地址：',
    fillInstrumentDeliveryAddress: '请务必填写文书送达地址',
    notes: '注意：法人和非法人组织机构代码和注册登记号都取调解中的统一信用代码',
    fillOrganizationsName: '请填写单位名称',
    organizationsNature: '单位性质：',
    organizationCode: '组织机构代码',
    registrationNumber: '注册登记号：',
    enterRegistrationNumber: '请输入注册登记号',
    legalRepresentative: '法定代表人',
    principalPersonInCharge: '主要负责人',
    principalPersonInCharge2: '主要负责人：',
    organizationCodeFormatError: '组织机构代码格式错误',
    registrationNumberFormatError: '注册登记号格式错误',
    onlineDelivery: '在线送达',
    mailDelivery: '邮寄送达',
    selectResidentArea: '请选择常住地区',
    selectOrganizationAddress: '请选择单位地址',
    enterAddress: '请输入文书送达地址',
    enterOrganiztionsName: '请输入单位名称',
    enterRequest: '请输入请求内容',
    operateAgain: '表单信息输入不正确，请重新操作',
    evidenceCompletedOrBlank: '每条证据材料必须填写完整或者都为空',
    queryPasswordEnter: '查询密码必须输入',
    judicialConfirmationSubmissionSucceed: '司法确认提交成功',
    mediationAgreement: '调解协议书',
    certificateOfJudicialConfirmation: '司法确认书',
    applicationJudicialConfirmation: '司法确认申请书',
    partysCertification: '当事人身份证明',
    fillIDNumber: '请填写证件号码',
    fillPhoneNumber: '请填写手机号码'
  },
  dossier: {
    listCases: '我的案件列表',
    casesMediated: '已调解案件',
    caseDetails: '案件详情',
    electronicFiles: '电子卷宗',
    disputeNo: '纠纷编号',
    identityStatus: '身份状态：',
    fileProgress: '卷宗进度',
    uploadMaterials: '上传资料',
    generateTheFile: '生成卷宗',
    catalogueInVolume: '卷内目录',
    fileCover: '卷宗封面',
    volumeName: '卷名',
    agreementNo: '协议编号',
    mediationDate: '调解日期',
    filingPeople: '立卷人：',
    filingDate: '立卷日期：',
    auditor: '审核人：',
    withdrawFile: '撤回卷宗',
    archiveFiles: '归档卷宗',
    withdrawalFiles: '撤回卷宗将清除卷宗记录和卷宗区文件。',
    reconfirmWhetherToSubmit: '再次确认是否提交，一旦提交无法修改。',
    revokeFile: '撤销卷宗',
    auditFailed: '审核失败',
    newFile: '卷宗新增',
    fileModification: '卷宗修改',
    archived: '已归档',
    auditSucceed: '审核成功',
    identityCertificate: '身份证明',
    listOfEvidence: '证据清单',
    clericalMaterials: '文书材料',
    letterAuthorization: '授权委托书',
    partysCertification: '当事人身份证明',
    agentsIdentification: '代理人身份证明',
    defaultAttachments: '默认附件',
    applicationMediation: '调解申请书',
    notice: '当事人权利义务告知书',
    mediationTranscript: '调解笔录',
    investigationTranscript: '调查笔录',
    mediationAgreement: '调解协议书',
    performanceProof: '调解协议履行证明',
    applicationJudicialConfirmation: '司法确认申请书',
    mediationReturnRecords: '调解回访记录',
    closingTable: '结案表',
    evidenceMaterial: '调解证据材料',
    selectCategory: '请选择分类',
    selectMaterial: '请选择材料名称',
    uploadFileFirst: '请先上传文件',
    withdrawalSucceed: '撤回成功',
    sentSuccessfully: '发送成功',
    notes: '备注',
    promptMessage: '提示信息'
  },
  detailold: {
    pendingMediationCases: '待调解案件',
    completedCases: '已完成案件',
    disputeDetails: '纠纷详情',
    reserveMeeting: '预约会议',
    workbench: '工作台',
    reassign: '重新分配',
    mediationAgreement: '调解协议',
    NoobjectionMediation: '无异议调解方案',
    NoncontroversialFactsConfirmation: '无争议事实确认协议',
    applicationJudicialConfirmation: '司法确认申请书',
    electronicFiles: '电子卷宗',
    followUpPhase: '后续阶段',
    mediationStatus: '调解状态',
    applicationForAssessmentReport: '申请评估报告',
    mediationRecords: '调解记录',
    participant: '参会者',
    mediationName: '调解名',
    enterVideo: '进入视频',
    assessmentReport: '评估报告',
    uploadFiles: '上传文件',
    assessmentReportBook: '评估报告书',
    peopleMediation: '人民调解',
    administrativeMediation: '行政调解',
    arbitrationMediation: '仲裁调解',
    judicialMediation: '司法调解',
    commercialMediation: '商业调解',
    lawyerMediation: '律师调解',
    notaryMediation: '公证调解',
    professionalMediation: '专业调解',
    industryMediation: '行业调解',
    deletingThePeople: '是否继续删除该案件人',
    continueDeletingfile: '是否继续删除该文件',
    deletionCanceled: '已取消删除'
  },
  detailRecord: {
    playDownload: '播放、下载',
    clickPlay: '点击播放 或 右击链接另存为'
  },
  applicantdata: {
    socialCreditCode: '社会信用代码',
    enterUnifiedSocialCreditCode: '请输入统一社会信用代码',
    fillOrganizationsName: '请填写单位名称',
    fillApplicantsName: '请填写申请人姓名',
    socialCreditCodeError: '社会信用代码输入错误',
    enterOrganiztionsName: '请输入单位名称',
    enterOrganization: '请输入机构名称',
    enterOrganizationRepresentative: '请输入机构代表人',
    fillRespondentsName: '请填写被申请人姓名'
  },
  //   organcenter
  distribution: {
    mediator1: '调解员：',
    organizationsManagementCenter: '机构管理中心',
    caseAssignment: '案件分配列表',
    enterNameNumberCase: '请输入姓名/编号/纠纷类型',
    search: '搜索',
    disputeType: '纠纷类型',
    expand: '展开',
    hide: '收起',
    registrationTime: '登记时间',
    sure: '确定',
    startDate: '开始日期',
    endingDate: '结束日期',
    searchResults: '搜索结果',
    disputeNo: '纠纷编号：',
    mediator: '调解员：',
    accept: '受理',
    notAccept: '不受理',
    allotMediators: '分配调解员',
    reallotMediators: '重新分配调解员',
    transferMediationOrganization: '转移调解机构',
    mediationProgress: '调解进度',
    disputeOccurred: '纠纷发生地',
    applicant: '申请人',
    applicantsAgent: '申请人代理人',
    respondent: '被申请人',
    respondentsAgent: '被申请人代理人',
    viewDetails: '查看详情',
    mediationOrganization: '调解机构',
    chooseMediator: '选择调解员',
    enterMediatorsName: '请输入调解员姓名',
    enterMediators: '请输入调解员',
    choose: '选择',
    progressDetails: '进度详情',
    currentStatus: '当前状态：',
    importantTips: '重要提示',
    acceptTheCase:
      '请您根据真实发生的纠纷情况决定是否受理该案件，若您选择“不受理”，将导致申请人无法享受本机构提供的调解服务。',
    notAcceptTheCase:
      '请您根据真实发生的纠纷情况决定是否受理该案件，若您选择“受理”，本机构调解员将为案件提供调解服务。',
    notAcceptCase: '不受理案件',
    reason: '原因',
    detailedReasons: '详细原因',
    transferOrganization: '转移机构',
    enterReasonsTransfer: '请先填写转出原因(必填)',
    selectType: '请选择类型',
    enterOrganization: '请输入机构名称',
    transfer: '转出',
    notUnderOrganization: '非本机构管辖',
    otherOrganizationsAccepted: '其他机构已受理/解决',
    mediationIsntGranted: '依案件性质不予调解',
    otherReasons: '其他原因',
    all: '全部',
    waitingMediation: '等待调解',
    isMediating: '正在调解',
    allTime: '所有时间',
    withinAWeek: '一周内',
    withinAMonth: '一月内',
    withinAYear: '一年内',
    customTime: '自定义时间',
    mediationTypes: '所有调解类型',
    peopleMediation: '人民调解',
    administrativeMediation: '行政调解',
    asssignMediatorSuccessfully: '分配调解员成功',
    transferMediationOrganizationSuccessfully: '转移调解机构成功',
    rejectSuccessfully: '不受理成功',
    acceptSuccessfully: '受理成功',
    allTypes: '所有类型'
  },
  addservice: {
    addServiceStaff: '添加服务人员',
    basicInformation: '基本资料',
    politicalStatus: '政治面貌',
    IDNumber: '身份证号',
    uploadIDCard: '身份证上传',
    front: '正面',
    reverseSide: '反面',
    contactPhone: '联系手机',
    contactEmail: '联系邮箱',
    degreeOfEducation: '文化程度',
    occupationInformation: '职业资料',
    areasOfExpertise: '擅长领域',
    separateWithCommas: '请用中文逗号隔开，如：婚姻纠纷，财产分配',
    qualificationCertificate: '资格证书',
    uploadTheCertificate: '证书上传',
    occupation: '职业',
    workingOrganization: '工作机构',
    workAddress: '工作地址',
    detailAddress: '详细地址',
    timeToStartWorking: '开始工作时间',
    careerExperience: '从业经历',
    platformFunction: '平台职能',
    typeOfFunction: '职能类型',
    serviceOrganization: '服务机构',
    serviceArea: '服务地区',
    add: '添加',
    save: '保存',
    queryServiceStaff: '查询服务人员',
    enterServiceStaffsTelephone: '请输入服务人员手机号',
    enterCorrectPhone: '请输入正确的手机号',
    sure: '确定',
    phoneNumberFormatError: '手机号码格式错误',
    wrongIDNumberFormat: '身份证号格式错误',
    separateAreasOfExpertise: '擅长领域请用中文逗号分隔',
    enterName: '请输入姓名',
    enterPhoneNumber: '请输入手机号',
    selectFunctionType: '请选择职能类型',
    selectServiceOrganization: '请选择服务机构',
    selectServiceArea: '请选择服务地区',
    CommunistPartyofChina: '中共党员',
    ProbationaryPartyMembers: '中共预备党员',
    communistYouthLeague: '共青团员',
    MDC: '民革党员',
    CDL: '民盟盟员',
    CDNCA: '民建会员',
    DPP: '民进会员',
    CPWDP: '农工党党员',
    thePublicParty: '致公党党员',
    JiusanSocietyMembers: '九三学社社员',
    TDSL: '台盟盟员',
    nonpartyPersonage: '无党派人士',
    ordinaryResident: '普通居民',
    modifyingServiceStuffSucceed: '修改服务人员成功',
    addingServiceStaffSucceed: '添加服务人员成功',
    nationality: '请选择国籍'
  },
  capabilitydetail: {
    assessmentDetails: '评估详情',
    name: '姓名',
    organization: '机构',
    assessmentCycle: '评估周期',
    assessmentResult: '评估结果',
    totalScore: '总得分',
    grade: '等级',
    processingRate: '处理率',
    weight: '权重',
    caseprocessingRate: '评估周期内案件处理率',
    numberOfCasesMediated: '已调解案件数',
    casesBeingMediated: '正在调解案件数',
    score: '得分',
    successRate: '成功率',
    successRateCasesProcessed: '评估周期内已处理案件成功率',
    numberOfSuccessfulMediation: '调解成功数',
    numberOfAssessments: '评价数',
    satisfaction: '满意度'
  },
  capabilityevaluate: {
    competencyAssessmentAnalysis: '能力评估分析',
    export: '导出',
    organization: '机构',
    assessmentCycle: '评估周期',
    affiliatedOrganization: '所属机构',
    assessmentScore: '评估得分',
    assessmentRating: '评估等级',
    operate: '操作',
    view: '查看',
    number: '序号',
    allOrganizations: '全部机构',
    allStaff: '全部人员',
    organizationalCapacityAssessment: '机构能力评估',
    capacityAssessment: '调解员能力评估'
  },
  comfirmlist: {
    organizationsManagementCenter: '机构管理中心',
    judicialConfirmationList: '司法确认列表',
    enterPersonnelName: '请输入人员姓名',
    search: '搜索',
    mediationType: '调解类型',
    expand: '展开',
    hide: '收起',
    registrationTime: '登记时间',
    sure: '确定',
    disputeNo: '纠纷编号',
    caseStatus: '案件状态',
    pendingConfirmation: '待确认',
    allocationOfJudges: '分配办案法官',
    confirm: '确认',
    caseDetails: '案件详情',
    caseProgress: '案件进度',
    judicialConfirmationCaseNo: '司法确认案号'
  },
  dossierdetail: {
    organizationManagement: '机构管理',
    fileRecords: '卷宗记录',
    fileDetails: '卷宗详情',
    fileProgress: '卷宗进度',
    progress: '卷宗进度',
    status: '状态',
    disputeNo: '纠纷编号',
    fileCatalogue: '卷宗目录',
    fileCover: '卷宗封面',
    volumeName: '卷名',
    caseNo: '案件编号',
    agreementNo: '协议编号',
    mediator: '调解员',
    mediationDate: '调解日期',
    filingDate: '立卷日期',
    remark: '备注',
    filingPeople: '立卷人',
    auditor: '审核人',
    passAudit: '通过审核',
    backToTheFile: '退回卷宗',
    currentStatus: '当前状态',
    confirmFileInformation: '确认卷宗信息无误？通过审核？',
    reasonsForReturn: '退回理由',
    enterReasonForReturn: '请输入退回理由',
    fileReviewPassed: '卷宗审核通过',
    reviewPassed: '审核通过',
    fileReturnedSuccessfully: '卷宗退回成功',
    catalogueInVolume: '卷内目录',
    backCover: '封底',
    revokeFile: '撤销卷宗',
    fileReviewFailed: '卷宗审核失败',
    newFile: '卷宗新增',
    fileReviewModified: '卷宗审核修改',
    fileHasBeenSubmitted: '卷宗已提交审核',
    fileReviewSucceed: '卷宗审核成功'
  },
  dossierlist: {
    organizationsManagementCenter: '机构管理中心',
    fileRecords: '卷宗记录',
    no: '编号',
    filingPeople: '立卷人',
    type: '类型',
    time: '时间',
    startDate: '开始日期',
    endingDate: '结束日期',
    fileNo: '卷宗编号',
    applicant: '申请人',
    filingTime: '立卷时间',
    viewDetails: '查看详情',
    currentOrganization: '当前机构',
    backfillFilterCriteria: '回填当前列表的过滤条件',
    saveFilterCriteria: '保存当前列表的过滤条件'
  },
  mediatelist: {
    caseMediationRecords: '案件调解记录',
    disputeMediation: '纠纷调解',
    migrated: '已转移',
    selectRegion: '选择地区',
    enterNameNumberCase: '请输入姓名/编号/案号',
    search: '搜索',
    disputeType: '纠纷类型',
    selectDistrictTown: '请选择区/镇',
    selectStreet: '请选择街道',
    selectProvince: '请选择省',
    selectCity: '请选择市',
    listOfProvinces: '省份列表',
    provinces: '省份',
    city: '城市',
    backfillFilterCriteria: '回填当前列表的过滤条件',
    customTime: '自定义时间',
    saveFilterCriteria: '保存当前列表的过滤条件'
  },
  organlist: {
    organizationsAdministrator: '机构管理员',
    serviceOrganizationList: '服务机构列表',
    serviceOrganization: '服务机构',
    mediationMethods: '调解方式',
    mediator: '调解员',
    organizationDetails: '机构详情',
    details: '机构详情',
    phone: '电话',
    personInCharge: '责任人',
    personInCharge2: '责任人：',
    address: '地址',
    address2: '地址：',
    contactPhoneNumber: '联系手机号',
    positionOfPerson: '负责人职位',
    contactEmail: '联系邮箱',
    organizationIntroduction: '机构简介',
    organizationsName: '机构名称',
    organizationsName2: '机构名称：',
    organizationsLandlineNumber: '单位座机',
    administrativeLevel: '行政级别',
    groupAddress: '机构地址',
    superiorOrganization: '上级单位',
    organizationCode: '组织机构代码',
    pleaseEnterOrganizationCode: '请输入组织机构代码',
    telephone: '电话：'
  },
  servicelist: {
    nationality: '国籍',
    serviceStaffList: '服务人员列表',
    enterPersonnelName: '请输入人员姓名',
    search: '搜索',
    serviceArea: '服务区域',
    areasOfExpertise: '擅长领域',
    expand: '展开',
    hide: '收起',
    details: '详情',
    details2: '详情：',
    starLevel: '星 级',
    numberOfAssessments: '评价数',
    practiceExperience: '{number}年执业经验',
    type: '类型',
    type2: '类型：',
    organization: '机构',
    organization2: '机构：',
    personnelDetails: '人员详情',
    yearsOfPractice: '执业年限',
    yearsOfPractice2: '执业年限：',
    typeOfFunction: '职能类型',
    serviceOrganization: '服务机构',
    pendingCompletion: '待完成',
    completed: '已完成',
    basicInformation: '基本资料',
    gender: '性别',
    degreeOfEducation: '文化程度',
    dateOfBirth: '出生日期：',
    politicalStatus: '政治面貌',
    contactPhone: '联系手机',
    IDNumber: '身份证号',
    contactEmail: '联系邮箱',
    typeOfOccupation: '职业类型',
    qualificationCertificate: '资格证书',
    workingOrganization: '工作机构',
    workAddress: '工作地址',
    careerExperience: '从业经历'
  },
  adjust: {
    applicationMediation: '调解申请书',
    return: '返回',
    basicInformation: '基本信息',
    courtAcceptedApplication: '申请受理法院',
    caseType: '案件类型',
    partysBasicInformation: '当事人基本信息',
    zipCode: '邮政编码',
    zipCode2: '邮政编码：',
    deliveryMethod: '送达方式',
    deliveryMethod2: '送达方式：',
    fillInstrumentDeliveryAddress: '请务必填写文书送达地址',
    instrumentDeliveryAddress: '文书送达地址',
    claimMatters: '请求事项',
    requestContent: '请求内容',
    requestContent2: '请求内容：',
    fillAppeals: '请填写诉求内容',
    evidenceMaterial: '证据材料',
    materialCategories: '材料分类',
    materialCategories2: '材料分类：',
    pleaseSelect: '请选择',
    materialName: '材料名称',
    materialAttachments: '材料附件',
    materialAttachments2: '材料附件：',
    clickToUploadFile: '点击上传文件',
    newMaterial: '新增材料',
    newMaterials: '多种材料，请点击“新增材料”',
    queryPassword: '查询密码',
    enterTheQueryPassword: '请输入查询密码',
    submitAnApplication: '提交申请',
    judicialConfirmationSubmissionSucceed: '司法确认提交成功',
    applicationJudicialConfirmation: '司法确认申请书',
    certificateOfJudicialConfirmation: '司法确认书',
    mediationAgreement: '调解协议书',
    partysCertification: '当事人身份证明',
    civil: '民事',
    organ: '机关',
    publicInstitution: '事业单位',
    peoplesOrganization: '人民团体',
    stateOwnedEnterprise: '国有企业',
    affiliatedEnterprise: '国有联营企业',
    collectivelyOwnedEnterprise: '集体企业',
    collectiveAffiliatedEnterprise: '集体联营企业',
    privateEnterprise: '私营企业',
    privatePartnershipEnterprise: '私营合伙企业',
    privateLiabilityLimitedCompany: '私营责任有限公司',
    individualBusiness: '个体工商户',
    individualPartnership: '个人合伙',
    SCollectiveAffiliatedEnterprise: '国有与集体联营企业',
    SOPrivateAffiliatedEnterprise: '国有与私人联营企业',
    CPrivateAffiliatedEnterprise: '集体与私人联营企业',
    collectiveAndPrivateEnterprise: '国有、集体与私人联营企业',
    limitedLiabilityCompany: '股份有限公司',
    limitedLiabilityCompany2: '有限责任公司',
    ChineseForeignJointVenture: '中外合资经营企业',
    ChineseForeignCoOperativeEnterprise: '中外合作经营企业',
    foreignFundedEnterprise: '外资企业',
    jointVentureEnterprise: '与大陆合资经营企业',
    jointOperationEnterprise: '与大陆合作经营企业',
    whollyOwnedEnterprises: '港、澳、台独资企业',
    army: '军队',
    otherEconomic: '其他经济'
  },
  applyRecord: {
    applicationFiling: '立案申请',
    operateAgain: '表单信息输入不正确，请重新操作!',
    evidenceCompletedOrBlank: '每条证据材料必须填写完整或者都为空',
    applicationForFilingSucceed: '申请立案成功'
  },
  judicialDetail: {
    filingProgressInquiry: '立案进度查询',
    caseInfo: '案件信息',
    serialNumber: '流水号',
    caseNo: '案号',
    courtOfAcceptance: '受理法院',
    caseType: '案件类型',
    causeAction: '案由',
    deliveryMethod: '送达方式',
    enforcementBasis: '执行依据',
    filingTime: '立案时间',
    sourceCase: '案件来源',
    litigationAmount: '诉讼标的额',
    identityOfTheFiling: '立案身份',
    litigationClaims: '诉讼请求',
    partysInformation: '当事人信息',
    partyType: '当事人类型',
    litigationStatus: '诉讼地位',
    agentLitem: '诉讼代理人',
    agentsSerialNumber: '诉讼代理人序号',
    nationality: '民族',
    typeOfDocument: '证件类型',
    typeOfDocument2: '证件类型：',
    pleaseSelectDocument: '请选择证件类型',
    zipCode: '邮政编码',
    nationality2: '国籍',
    politicalStatus: '政治面貌',
    degreeOfEducation: '文化程度',
    legalRepresentative: '法定代表人',
    legalRepresentativesTypeOfDocuments: '法定代表人证件种类',
    legalRepresentativesIDNumber: '法定代表人证件号码',
    agentsInformation: '代理人信息',
    typeDefense: '辩护类型',
    agentsName: '代理人姓名',
    agentsPhoneNumber: '代理人电话',
    agentZIPCode: '代理人邮政编码',
    agentsAddress: '代理人地址',
    agentsPractisingCertificateNumber: '代理人执业证号',
    typesOfAgentDocuments: '代理人证件种类',
    agentIDNumber: '代理人证件号码',
    agentsOrganization: '代理人所在单位',
    serialNumber2: '代理人对应当事人序号',
    reviewInformation: '审查信息',
    caseStatus: '案件状态',
    reviewer: '审查人',
    dateOfReview: '审查日期',
    reviewOpinions: '审查意见',
    reasonsForReviewOpinions: '审查意见理由',
    age: '年龄',
    partyNumber: '当事人序号'
  },
  //   lawsuit
  applylawsuit: {
    applicationForLitigation: '申请诉讼',
    enterKeywords: '可输入关键词进行搜索',
    amountOfSubject: '标的额',
    enterAmountOfSubject: '请输入标的额',
    requestContent: '请求内容',
    fillAppeals: '请填写诉求内容',
    appealMaterials: '诉求资料',
    materialCategories: '材料分类',
    materialName: '材料名称',
    materialAttachments: '材料附件',
    clickToUploadFile: '点击上传文件',
    newMaterial: '新增材料',
    newMaterials: '多种材料，请点击“新增材料”',
    submitAnApplication: '提交申请',
    selectCourt: '选择法院',
    successfulSubmission: '诉讼申请提交成功',
    reselect: '当前法院和案件类型下没有案由，请重新选择',
    proceedingDetails: '诉讼详情'
  },
  disputeType: {
    all: '全部',
    NPL: '网络产品责任纠纷',
    NC: '网络著作权、邻接权权属纠纷',
    OS: '网络购物合同纠纷',
    NDN: '网络域名权属、侵权及合同纠纷',
    NI: '网络侵害他人人身权、财产权等民事权益纠纷',
    NPI: '网络公益诉讼',
    NSC: '网络服务合同纠纷',
    AD: '网络行政管理引发的行政纠纷',
    NFL: '网络著作权、邻接权侵权纠纷',
    NR: '网络金融借款合同纠纷、小额借款合同纠纷',
    other: '其他纠纷',
    DOPR: '人格权纠纷',
    DOMFAS: '婚姻家庭、继承纠纷',
    DPR: '物权纠纷',
    DCIPANG: '合同、无因管理、不当得利纠纷',
    DIPAC: '知识产权与竞争纠纷',
    DLAP: '劳动争议、人事争议',
    DMAM: '海事海商纠纷',
    CDOCSIA: '与公司、证券、保险、票据等有关的民事纠纷',
    DOTL: '侵权责任纠纷',
    CAFCSTSP: '适用特殊程序案件案由'
  },
  room: {
    invite: '邀请',
    happy: '高兴：',
    angry: '愤怒：',
    sad: '悲伤：',
    calm: '平静：',
    afraid: '恐惧：',
    annoyed: '厌恶：',
    surprised: '惊奇：',
    disputeMaterials: '纠纷材料',
    voice: '语音',
    video: '视频',
    privateChat: '私聊',
    EmotionsOfCalm:
      '系统将通过面部表情识别出平静、高兴、<br>愤怒、恐惧、悲伤、厌恶、惊奇7种情绪，<br>调解过程中若当事人情绪过于愤怒或悲伤时<br>会发出预警，以协助您更好的调解纠纷。',
    detectVideoAndAudio: '检测音视频',
    playDiscipline: '播放纪律',
    endVideo: '结束视频',
    stopRecording: '停止录制',
    startRecording: '开始录制',
    startRecording2: '开始录制2',
    startRecording3: '当前视频正在录制中',
    startRecording4: '正在录制',
    stopRecording2: '当前视频已停止录制',
    leave: '离开视频',
    quitVideoConference: '退出了视频会议',
    shareFaceExpressionRecognition: '人脸表情识别占比（%）',
    communicationRecords: '沟通记录',
    videoTurnedOff: '视频被关闭',
    observer: '观摩人',
    browserNotSupportVideo:
      '当前浏览器不支持视频会议，请使用Chrome(版本要求高于52)或者QQ浏览器(10.2)',
    connectionIsInterrupted: '会议连接中断',
    videoConnectionFailed: '视频连接失败，请重试',
    retry: '重试',
    whetherToEnd: '是否结束当前视频会议？',
    whetherToRcording: '是否开始录制视频？',
    whetherToStopRecording: '是否结束录制视频？',
    cantBeSccessedAgain: '结束视频后，本次视频调解将结束，不能再次进入视频',
    leaveTemporarily: '暂时离开',
    endRecording: '结束录制',
    enterWithinOneHour:
      '请于1小时内进入视频，否则系统将默认结束本次视频调解。。。',
    leaveVideo: '离开视频，视频页面将会关闭',
    comfirmAndLeave: '视频会议已结束，请确定离开',
    videoClosedByMediatorTip_1: '调解员临时屏蔽您的音视频',
    videoClosedByMediatorTip_2: '请静待恢复',
    videoForbidden: '已屏蔽',
    videoRecovery: '解除屏蔽',
    voiceTotext: '调解员开启了语音转文字功能,语音将自动转换为文字生成调解笔录',
    voiceTotextOff: '调解员关闭了语音转文字功能'
  },
  level: {
    low: '低',
    middle: '中',
    high: '高'
  },
  insideCaseInfo: {
    name: '姓名：'
  },
  header: {
    hello: '您好，',
    online: '在线',
    busy: '繁忙',
    exit: '退出',
    home: '首页',
    LegalAdvice: '法律咨询',
    more: '更多',
    lawsAndRegulations: '法律法规',
    caseLibrary: '案例库',
    regulatoryCase: '法律法规案例库',
    serviceResources: '服务资源',
    helpCenter: '帮助中心',
    mediationCentre: '调解中心',
    FAQ: '常见问题',
    welcomeToRegister: '欢迎注册',
    alreadyHave: '已有帐号？',
    pleaseLogin: '请登录',
    welcomeToLogin: '欢迎登录',
    staffLogin: '工作人员登录',
    retrievePassword: '找回密码',
    backLogin: '返回登录',
    backToHome: '返回首页',
    help: '帮助',
    resourceDatabase: '涉外民商事调解资源库'
  },
  inside: {
    communicationRecords: '沟通记录',
    InSpeechRecognition: '语音识别中',
    turnOnSpeechRecognition: '开启语音识别',
    manual: '手动输入',
    speechRecognition: '语音识别',
    pressENTERToSend: '在此输入消息，按回车键发送',
    mediationGuideline: '调解指引',
    mediationGuidelineCase: '{type}类型案件调解指引',
    videoCertification: '视频认证',
    authenticateTheParties: '是否同意对当事人进行身份认证？',
    materialUpload: '材料上传',
    tip: '提示：当前纠纷为“{type}”，建议的证据有{evidence}上传文件不超过20M'
  },
  privatechat: {
    noChatInformation: '当前没有聊天信息',
    inConversation: '正在与{somebody}交谈中',
    privateChatWindow: '私聊窗口'
  },
  other: {
    year: '年',
    language: '语言',
    day: '天',
    protocol: '《海南涉外民商事法庭案件多元化解平台服务协议》'
  },
  leftMenu: {
    securitySettings: '安全设置',
    myProfile: '我的资料'
  },
  footer: {
    userCenter: '用户中心',
    howToMediate: '如何进行调解',
    howToViewResults: '如何查看结果',
    mediationCentre: '调解中心',
    platformService: '平台服务',
    litigationService: '诉讼服务',
    contactMethod: '联系方式',
    customerServiceTel: '客服电话：',
    customerServiceEmail: '客服邮箱：',
    smallProgram: '小程序'
  },
  realName: {
    realNameCertification: '实名认证',
    name: '姓 名：',
    IdNumber: '身份证：'
  },
  home: {
    personalCenter: '进入个人中心',
    exit: '退出',
    login: '登录',
    enterPhoneOrEmail: '请输入手机号或邮箱',
    register: '立即注册',
    contactAdministrator: '其他问题联系管理员',
    passwordLogin: '账号密码登录',
    captchaLogin: '验证码登录',
    ukeyLogin: 'UKEY登录',
    phoneNumberCantBeBlank: '手机号不可为空',
    emailFormatError: '邮箱格式错误',
    staff: '工作人员',
    onlineDisputeResolution: '在线多元化解',
    onlineDisputeResolution2:
      '矛盾纠纷在线录入，权威资源在线响应，多元资源专业支持，矛盾纠纷快速化解',
    qualityTeam: '优质团队 化解纠纷',
    qualityTeam2: '按类型高效匹配机构调解员',
    saveTime: '省时省力 维护权益',
    saveTime2: '足不出户，一键解纷',
    wholeProgress: '全场跟踪 案件进展',
    SMSNotification: '案件流转全流程短信通知',
    organizer: '主办单位：',
    ChineseDomain: '中文域名：',
    filingNumber: '备案号：',
    courtAddress: '法院地址：',
    courtTel: '法院电话：',
    technicalServiceHotline: '技术服务热线：',
    welcome: '欢迎您',
    welcomeTo: '欢迎您来到海南法院涉外民商事法庭案件多元化解平台',
    professional: '专业咨询师、机构调解员，多元化解纷资源',
    guidingCase: '引调案件',
    hello: '您好，',
    please: '请',
    mediation: '纠纷调解:',
    case: '例',
    title1: '港澳台案例',
    content1:
      '港澳台案例是指案件的当事人是中国香港特别行政区、澳门特别行政区、台湾地区的公民或者组织，或者诉讼标的、涉诉的法律关系发生在港澳台地区，包括民商事案例、刑事案例及行政案例等。',
    title2: '最高院指导性案例',
    content2:
      '最高院指导性案例是指依据《最高人民法院关于案例指导工作的规定》程序编选的，由最高人民法院审委会讨论并统一发布，代表最高人民法院意志的，各级人民法院在审判类似案件时应当参照的指导性案例。该类案例往往受社会广泛关注、涉及法律原则、具有典型意义、涉及疑难复杂或者新类型问题或有其他指导作用。',
    title3: '一带一路涉外案例',
    learnMore: '了解详情',
    HainanFreeTradeZone: '海南自贸区',
    content3:
      '一带一路涉外案例是指案件含有涉外因素，包括主体、标的或法律关系的内容涉外的民商事案件，行为发生地、结果发生地、实施主体或诉讼过程涉外的刑事案件，外国原告或第三人针对中国行政机关提起诉讼的行政案件。涉及“一带一路”建设的指导性案例是指由最高人民法院在梳理、总结近年来涉外海事海商审判工作经验的基础上，集中发布的指导性案例，旨在统一涉外商事、海事案件审判法律适用，实现类案同判。',
    knowMore: '了解详情'
  },
  service: {
    workingExperience: '从业经验',
    noEvaluation: '暂无评价',
    searchOrganization: '搜索 机构',
    searchStaff: '搜索 人员',
    searchLawyer: '搜索 公益律师'
  },
  agreementRegister: {
    serviceAgreement: '海南法院涉外民商事法庭案件多元化解平台服务协议',
    versionEffectiveDate: '版本生效日期：',
    time: '2018年04月14日 10:49',
    indent:
      '“海南法院涉外民商事法庭案件多元化解平台”（以下简称“多元平台”）是在线纠纷解决方式的一体化服务平台，旨在通过在线方式为人民群众提供咨询、调解、仲裁、评估、诉讼等服务。在使用多元平台的各项服务前，请您务必仔细阅读并透彻理解本协议，特别是免除或限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。您可以选择不使用多元平台服务，但如果您使用多元平台服务即视为您认可了本服务协议的所有内容。',
    indent2:
      '当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与多元平台达成一致，成为多元平台“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。',
    title: '一、知识产权声明',
    content:
      '多元平台拥有多元平台网站内所有信息内容、使用技术、设计样式、设计程序的知识产权，任何为商业目的复制和传播本网站内信息的行为都可能构成对本网站知识产权的侵犯，本网站将依法维护自身的权利。未经多元平台许可，任何人不得擅自使用。否则，多元平台将依法追究法律责任。',
    title2: '二、关于隐私权的规定',
    num1:
      '1. 多元平台尊重并保护所有使用多元平台用户的个人隐私权。包括您在多元平台提供的户名、IP地址、银行账户、邮箱、联系方式、浏览器的类型、访问时间、软硬件特征信息及您需求的网页记录等数据。多元平台不会向第三方(与多元平台存在合作关系的公司除外)提供、分享您的个人信息。',
    num2:
      '2. 您在使用多元平台进行交易的有关数据、您的信用评价、多元平台因您违法或违约而对您采取的处理决定，均为本网站的公开信息，不是隐私权的保护范围。',
    num3:
      '3. 多元平台不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息，任何多元平台用户如从事上述活动，请受害者及时书面告知多元平台并提供相关证据，经本网站审查属实后，或者本网站自行发现这种侵权情况时，网站将有权立即终止与侵权用户的服务协议。',
    num4:
      '4. 如不属于多元平台用户的第三者利用您在本网站的信息侵害您的权益，因本网站无权对非本网站用户采取措施，请您及时依法维护自己的权利，本网站将给予必要的配合。',
    num5:
      '5. 为了更好地为您服务或者保护其他多元平台用户的合法权益，多元平台有权通过使用您提供的个人信息，向您发送相关信息，采取保护您的隐私的措施，进行相关的调查。',
    num6:
      '6. 如果您就您的隐私和信息向多元平台投诉其他侵权人，多元平台有权将您与投诉相关的信息及权利证明向被投诉人披露，以便维护您的权益和解决纠纷。',
    num7:
      '7. 如果您被投诉或者违反国家法律、法规、多元平台的服务协议和相关规则，多元平台有权向相关方披露您的信息，但该披露以保护合法权益者的利益为限。',
    num8:
      '8. 在多元平台的咨询者需要与咨询师交流或交易时，作为交易双方的咨询者和咨询师均为交流或交易需要而有权知道对方相关的信息，知道对方交易信息的一方均负有义务不向第三方泄露对方的信息。如果您侵权泄露他人的信息，在受害方能证实侵权的情况下，多元平台有权向受损害方和国家相关部门披露您的信息。',
    num9:
      '9. 为了实现您登陆本网站的目的，或者多元平台出于与您交流或者交易的需要，多元平台有权在合理限度内使用您的信息。',
    num10:
      '10. 请您妥善保护好您的账户、密码，多元平台也将采取技术措施，防止您的信息被泄露，但您认可因当前技术和现实的限制，没有百分百绝对安全的技术措施，在多元平台没有故意行为时，不对此承担法律责任。'
  },
  registersuccess: {
    registrationIsCompleted: '注册已完成！',
    completeRealNameCertification: '完成实名认证',
    registerAccount: '纠纷登记',
    toRegister: '填写手机号密码进行注册',
    fillTheCaseInformation: '填写案件信息，上传证据材料',
    onlineMediation: '在线调解',
    organizeOnlineVideoMediation: '调解员了解纠纷详情，组织在线视频调解',
    partiesReachMediationAgreement: '双方当事人达成调解协议',
    ApplyJudicialConfirmation: '申请司法确认',
    judicialConfirmation: '双方当事人共同申请司法确认',
    enterIDNumber: '请输入二代身份证号',
    realNameCertificationSucceed: '恭喜您，实名认证成功！',
    viewTheInformation: '您可以到个人中心查看实名后的资料。'
  },
  question: {
    platformGuide: '平台指南',
    userLogin: '用户登录',
    platformService: '平台服务',
    mediationServiceForDisputes: '纠纷调解服务',
    serviceResources: '服务资源',
    usageProcess: '使用流程',
    applicationForMediation: '申请调解',
    viewResults: '查看结果',
    accountSettings: '账户设置',
    realNameAuthentication: '实名认证',
    modifyPassword: '修改密码',
    personalInformation: '个人信息',
    handwrittenSignature: '手写签名',
    register1: '新用户可点击平台首页右上角的“注册”按钮，进入注册页面。',
    register2:
      '新用户输入手机号码→点击“获取验证码”→输入验证码→进行密码设置，填写完成后，用户点击《海南涉外民商事法庭案件多元化解平台》进行查看，查看后勾选我同意《海南涉外民商事法庭案件多元化解平台》选项，代表已阅读并同意服务条款。',
    register3:
      '点击“注册”按钮，弹窗提示用户注册成功，用户可自行选择是否前往个人中心完善个人信息。',
    login1:
      '用户可点击平台首页右上角的“登录”按钮，进入登录页面，输入手机号和密码，点击“登录”按钮即可成功登录平台。登录后可享受在线咨询、在线调解、在线诉讼等服务。',
    forgetPwd: '忘记密码',
    login2:
      '用户可点击平台首页右上角的“登录”按钮，进入登录页面，如果忘记账号的密码，可点击“忘记密码 ?”按钮，输入“手机号”、“手机验证码”、“新密码”、“重复密码”这几项必填信息，点击“确认”按钮，系统提示密码修改成功。用户可使用账号和新密码登录平台。',
    userRegistrationAgreement: '用户注册协议',
    agreement:
      '《海南涉外民商事法庭案件多元化解平台》为平台与“用户”间达成的协议，用户在注册时需阅读该协议，确认相关信息。《协议》内容包括平台知识产权声明、隐私权的规定、注册及使用细则、平台使用规则、相关费用规定、争议解决方式、违约责任、协议的修改及终止和其他约定等内容，平台已将上述免除或者限制责任的条款以粗体下划线标识，提示“用户”重点阅读。',
    introductionToDisputeMediationService: '纠纷调解服务简介',
    mediation:
      '调解是指由双方当事人以外的第三者，以国家法律、法规和政策以及社会公德为依据，对纠纷双方进行疏导、劝说，促使他们相互谅解，进行协商，自愿达成协议，解决纠纷的活动。',
    applicant:
      '申请人可在平台申请调解案件并可选择自己的意向调解机构，调解机构管理员分配该案件给合适的调解员，调解员将联系当事人处理该纠纷。',
    types: '纠纷调解服务有哪些类型',
    platform: '平台将纠纷调解分为人民调解、行政调解。',
    mediator: '什么是“调解员”',
    serviceStaff:
      '调解员是指在平台上线的调解组织中担负调解民间纠纷工作的服务人员，工作内容主要是通过说服、疏导等方式，促使当事人在平等协商基础上自愿达成调解协议，化解矛盾、消除纷争。',
    administrator: '管理员在平台主要负责什么',
    platformMediationOrganization:
      '平台调解机构的管理员在调解过程中主要负责决定是否受理用户的调解案件、分配相应的调解员以及对最终卷宗的审核。',
    responsible: '调解员在平台主要负责什么',
    mainlyResponsible:
      '平台调解机构的调解员主要负责联系调解案件的当事人了解矛盾纠纷的情况，并组织线上视频会议或线下会议对矛盾纠纷进行化解，最终根据调解结果撰写相应的文书，在平台设置调解状态后负责对卷宗进行归档。',
    difference: '律师调解员和普通调解员的区别',
    lawyerMediator:
      '律师调解员同时也是律师，相对于普通调解员，律师调解员具有专业的法律知识和娴熟的职业技能、快速理清各方的矛盾争议焦点、非官方的身份更容易让当事人产生信任，亲和力更强，调解效率更高。',
    serviceResources2: '平台有哪些服务资源',
    resourcesOfIndustries:
      '平台汇集了各条线各行业的解纷资源，主要分为人民调解、行政调解，构建了一套有机衔接的“社会化的调解体系”；平台召集了各机构的资深人员构建更强大、更专业的专家咨询库，为公众提供更高品质的咨询服务',
    howToMediate: '如何进行调解',
    userApplies:
      '纠纷登记员将根据案情将纠纷登记至海南涉外民商事在线多元化解平台委托调解机构进行调解。案件进入调解后，调解员会发送信息至双方当事人。请留意手机短信通知，并及时登陆海南涉外民商事在线多元化解平台参与调解。',
    viewMediationResults: '如何查看调解结果',
    logingOnThePlatform:
      '用户登录平台后，可在调解列表中查看所有与自己相关的调解案件，列表展示案件的调解进度，点击“纠纷详情”按钮可查看案件详情和相关文书材料。用户也可根据调解进度对案件进行筛选。（服务-调解）',
    completeRealNameAuthentication: '如何完成实名认证',
    afterUserLogs:
      '用户登录平台后，可在账户中心-安全设置-身份认证中，填写姓名、身份证号进行实名认证。对于无二代身份证的用户，可在调解中与调解员进行视频认证进行核验。',
    whyNeedRealNameAuthentication: '为什么要实名认证',
    improveAccountSecurity:
      '实名认证可提升账号安全级别和信任级别，在申请调解时，系统也将自动导入实名认证的信息，避免重复输入。',
    modifyThePassword: '如何修改密码',
    clickModify:
      '用户登录后在安全设置-登录密码点击“修改”按钮，输入原密码、新密码、点击“确认”按钮即可成功修改密码。',
    completePersonalInformation: '如何完善个人信息',
    personalDataSection:
      '用户登录平台后，可在账户中心下设的安全设置和个人资料板块中对个人信息进行完善.',
    useOfEmail: '邮箱有什么用途',
    identifyPersonalInformation:
      '邮箱作为辨别个人信息的途径之一，绑定邮箱可提高用户使用平台的安全性，为各项信息的通知提供便利。',
    twoAddresses: '两个地址有什么关系 ?（户籍地址、现居地址）',
    permanentResidenceAddress:
      '户籍地址为用户户口登记所在的地址，现居地址为用户实际常住的地址，两个地址可一致也可不一致，现居地址会被系统直接提取作为咨询、评估、调解时的相应纠纷发生地。',
    availableOnThePlatform: '平台有哪些签名方式',
    instrumentMaterials:
      '对于需要当事人签署的文书材料（例如调解笔录、调解协议、司法确认申请书等），平台提供了手写签名的方式进行签署。',
    handwrittenSignature2: '手写签名如何进行',
    elevantMaterialInstruments:
      '在调解员发送相关文书材料后，用户在“工作台”（纠纷详情或视频会议界面）点击相应文书，若无异议，可点击“同意”按钮，点击后系统自动弹出二维码，用户可用微信扫描二维码进行手写签名，点击“确定”代表文书材料签署成功。',
    userRegistration: '用户注册'
  },
  help: {
    stepsMediation: '申请调解步骤',
    courtLedMediation: '法院引调',
    allocationMediation: '调解案件分配调解机构',
    platformNotifies: '平台通知双方当事人',
    SMSNotifies: '短信通知及时线上调解',
    mediatesOnline: '调解员在线调解',
    mediatorIntervene: '调解员介入，进行调解',
    successfulMediation: '调解成功',
    mediatorConfirms: '调解员确认调解状态',
    judicialConfirmationOrMediation: '申请司法确认或调解书',
    judicialConfirmation: '申请司法确认',
    regAcc: '纠纷登记员登记纠纷信息',
    appMed: '短信或邮件通知及时线上调解',
    medOnl: '调解员介入，三方在线视频调解',
    medSuc: '调解成功，在线确认调解协议',
    appJud: '在线申请法院确认调解协议效力'
  }
}



// WEBPACK FOOTER //
// ./src/publicResource/utils/lang/zh.js